import React from 'react';
import Card from '../../components/ui/Card/Card';
import Skeleton from '../../components/ui/Skeleton/Skeleton';
import styles from './Deliveries.module.css';

const DeliveriesSkeleton: React.FC = () => (
  <div className={styles.page}>
    <Card>
      <div className={styles.header}>
        <Skeleton width={180} height={28} />
        <div className={styles.headerActions}>
          <Skeleton width={140} height={40} className={styles.skRounded} />
          <div className={styles.search}>
            <Skeleton width="100%" height={44} className={styles.skRounded} />
          </div>
        </div>
      </div>

      <div className={styles.tableWrap}>
        <div className={styles.tableHead}>
          {Array.from({ length: 6 }).map((_, i) => (
            <Skeleton key={i} width="70%" height={13} />
          ))}
        </div>
        <div className={styles.tableBody}>
          {Array.from({ length: 8 }).map((_, r) => (
            <div key={r} className={styles.row}>
              <Skeleton width="80%" height={14} />
              <Skeleton width="50%" height={14} />
              <Skeleton width="85%" height={14} />
              <Skeleton width="60%" height={14} />
              <Skeleton width="80%" height={14} />
              <span className={styles.center}>
                <Skeleton width={70} height={30} className={styles.skRounded} />
              </span>
            </div>
          ))}
        </div>
      </div>
    </Card>
  </div>
);

export default DeliveriesSkeleton;
